import { initializeSearchSitewide } from './search/searchSitewide.js';
import { initializeSearchFundingDecisions } from './search/searchFundingDecisions.js';
import { initializeSearchFilms } from './search/searchFilms.js';
import { initializeSearchNews } from './search/searchNews.js';
import { initializeHeader } from './header/index.js';
import { initializeBackButton } from './includes/backButton.js';
import { initializeMediaDialog } from './includes/mediaDialog.js';
import { initializeHomeMedia } from './includes/home.js';
import { initializeAddToCalendarButtons } from './includes/addToCalendar.js';
import { initaliseFooter } from './includes/footer.js';
import { initalisePrefooter } from './includes/prefooter.js';
import { initializeContactForm } from './contact/form.js';
import { initaliseSplide } from './includes/splide.js';
import { initalizeShowreels } from './includes/showreels.js';
import { initializeOverflowContainers } from './includes/overflowContainer.js';
import { initializeFilterableCompanies } from './includes/filterableCompanies.js';
import { initializeToggleTheme } from './includes/toggleTheme.js';
import { initializeResponsiveClasses } from './includes/responsiveClasses.js';
import { initializeFadeAnimation } from './includes/animations.js';
import { initializeAnalytics } from './includes/analytics.js';
import { addAnchorIdsToHeadings } from './includes/addAnchorIdsToHeadings.js';
import { initializeAccordion } from './includes/accordion.js';
import { initialiseVideoPlaceholder } from './includes/videoPlaceholder.js';

document.addEventListener('DOMContentLoaded', () => {
    initializeSearchSitewide();
    initializeHeader();
    initializeBackButton();
    initializeSearchFundingDecisions();
    initializeSearchFilms();
    initializeSearchNews();
    initializeMediaDialog();
    initializeHomeMedia();
    initializeAddToCalendarButtons();
    initaliseFooter();
    initalisePrefooter();
    initializeContactForm();
    initaliseSplide();
    initalizeShowreels();
    initializeOverflowContainers();
    initializeFilterableCompanies();
    initializeToggleTheme();
    initializeResponsiveClasses();
    initializeFadeAnimation();
    initializeAnalytics();
    initializeAccordion();
    addAnchorIdsToHeadings();
    initialiseVideoPlaceholder();
});
